import { create } from 'zustand';

export type PaletteKey = 'editorial-neutral' | 'modern-minimalist' | 'cyber-street' | 'dark-luxe';

interface ThemeState {
  palette: PaletteKey;
  setPalette: (palette: PaletteKey) => void;
  toggleTheme: () => void;
}

const STORAGE_KEY = 'fa-theme-preference';

const VALID_PALETTES: PaletteKey[] = ['editorial-neutral', 'modern-minimalist', 'cyber-street', 'dark-luxe'];

const getInitialPalette = (): PaletteKey => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && VALID_PALETTES.includes(stored as PaletteKey)) {
      return stored as PaletteKey;
    }
  } catch {
    // localStorage unavailable (SSR, private browsing)
  }
  return 'editorial-neutral';
};

export const useThemeStore = create<ThemeState>((set) => ({
  palette: getInitialPalette(),
  setPalette: (palette) => {
    try { localStorage.setItem(STORAGE_KEY, palette); } catch {}
    set({ palette });
  },
  toggleTheme: () =>
    set((state) => {
      const idx = VALID_PALETTES.indexOf(state.palette);
      const next = VALID_PALETTES[(idx + 1) % VALID_PALETTES.length];
      try { localStorage.setItem(STORAGE_KEY, next); } catch {}
      return { palette: next };
    }),
}));
